// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__xllKm","jpCurrentDate":"JP_Footer_jpCurrentDate__p6af-","jpFootage":"JP_Footer_jpFootage__w7qw4","higlight":"JP_Footer_higlight__TON8R"};